// extracted by mini-css-extract-plugin
export default {"container":"CardAbout_container__G+mpc"};